export default __webpack_public_path__ + "static/2040-5-84d70e2ae6bbbe44822192e015b6e505.jpg";